
import Vue from 'vue'

export default Vue.extend({
  props: {
    itemData: {
      type: Object as () => ProductData,
      required: true,
    },
  },
})

interface ProductData {
  translations: {
    slug: string;
    cover: string;
    name: string;
  }[];
}
